import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';

export const Wrapper = styled(motion.div)<{ $minHeight?: number }>`
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: linear-gradient(206.7deg, #323232 0.77%, #404148 20.42%, #242424 73.73%);
    border-radius: 10px;
    width: 100%;
    height: 100%;
    min-height: 299px;
    position: relative;
    z-index: 0;
    padding: 6px;
    opacity: 0.5;

    ${({ $minHeight }) =>
        $minHeight &&
        css`
            min-height: ${$minHeight}px;

            @media (max-width: 768px) {
                min-height: ${$minHeight / 1.5}px;
            }
        `}
`;

export const Asset = styled.div`
    background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    aspect-ratio: 1;
    border-radius: 10px;
`;
